import { render, staticRenderFns } from "./BaoCaoPLDGNDD.vue?vue&type=template&id=54531e38&scoped=true"
import script from "./BaoCaoPLDGNDD.vue?vue&type=script&lang=ts"
export * from "./BaoCaoPLDGNDD.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54531e38",
  null
  
)

export default component.exports